import { computed, unref, watch, type MaybeRef, type Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { skillsApi } from '@/api/skills';

// Skills are career-bound: this loads the catalog for the currently selected
// career and clears the form's selection whenever the career changes, so a
// stale skill of the previous career can't be submitted. Used by the caregiver
// and requirement forms (single- vs multi-select handled via `emptyValue`).
// `enabled` lets callers further gate the query (e.g. behind care planning).
export function useCareerSkills(
  career: Ref<string | null | undefined>,
  selection: Ref<number | number[] | null | undefined>,
  emptyValue: number[] | null,
  enabled: MaybeRef<boolean> = true,
) {
  const { data: careerSkills } = useQuery({
    queryKey: ['skills', career],
    queryFn: () => skillsApi.index(career.value ?? undefined),
    enabled: computed(() => !!career.value && !!unref(enabled)),
  });

  watch(career, (newCareer, oldCareer) => {
    if (oldCareer && newCareer !== oldCareer) selection.value = emptyValue;
  });

  return { careerSkills };
}
